<template>
  <b-card :title="title">
    <b-row v-if="reportList?.length > 0" class="mt-4">
      <div
        v-for="report in reportList"
        :key="report.key"
        :class="{
          'col-md-3': screenWidth > 1538,
          'col-md-4': screenWidth <= 1538,
        }"
      >
        <b-col
          v-if="hasAccess(['favorite-reports:read']) && !report.isSaved && !report.isCustom"
          class="favorite-btn"
        >
          <i
            title="Jadikan Favorit"
            :class="`mc-fa icon-${report.isFavorite ? 'fill' : 'outline'}_star font-size-24`"
            @click="onFavorite(report.key)"
          ></i>
        </b-col>
        <b-col
          v-if="hasAccess(['saved-reports:read']) && report.isSaved && !report.isCustom"
          class="saved-btn"
        >
          <i
            title="Laporan Tersimpan"
            :class="`mc-fa icon-fill_bookmark font-size-24`"
            @click="onDelete(report.savedId)"
          ></i>
        </b-col>
        <a @click="onClickReport(report)">
          <b-card class="border border-1 pb-3 report-card">
            <b-row class="mb-3">
              <b-col cols="10">
                <h5 class="mc-general__label">{{ report.labelName ?? $t(report.label) }}</h5>
              </b-col>
            </b-row>
            <p class="mc-general__label mb-5">
              {{ report.isDescDefault === false ? report.desc : $t(report.desc) }}
            </p>
            <div class="report-tag-container">
              <div v-for="(tag, index) in report.category" :key="tag" class="d-inline-block">
                <div>
                  <span
                    v-if="index < (report.desc?.length < 40 ? 3 : 2)"
                    class="badge report-tag-badge me-2"
                  >
                    {{ $t(`report.report.tag.${tag}`) }}
                  </span>
                </div>
                <div>
                  <span
                    v-if="index === (report.desc?.length < 40 ? 4 : 3)"
                    class="badge report-tag-badge me-2"
                  >
                    +{{ report.category?.length - (report.desc?.length < 40 ? 3 : 2) }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="report.isCustom" class="badge custom-report">
              <i class="mc-fa icon-outline_brush font-size-20" />
            </div>
          </b-card>
        </a>
        <ModalFilter :id="report.modal" :report="report" />
      </div>
    </b-row>
    <b-row v-else class="mt-4">
      <h5 class="text-center">
        {{ $t('global.text.noData') }}
      </h5>
    </b-row>
  </b-card>
</template>
<script>
import { UPDATE_FAVORITE_REPORTS } from '@/services/api/report/report'
import { mapGetters } from 'vuex'
import ModalFilter from '@/router/views/report/components/ModalFilter'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  components: {
    ModalFilter,
  },
  mixins: [Helper, MixPanel],
  props: {
    title: {
      type: String,
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      screenWidth: window.innerWidth,
    }
  },
  computed: {
    reportList() {
      return this.list
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },

  methods: {
    onDelete(savedId) {
      this.$emit('onDelete', savedId)
    },
    openModal(report) {
      this.$bvModal.show(report.modal)
    },

    onClickReport(report) {
      if (report.isCustom) {
        const user = this.$store.state.identity.whoami

        this.track('Open Custom Report', {
          'domain-name': window.location.href,
          'user-id': user.userId,
          'report-name': report.label,
          'metabase-id': report.content_id,
        })
        this.$router.push({ name: 'Custom Report', params: { id: report.uuid } })
      } else {
        if (report.filterValue) {
          const { periode, periodeMonth, dateType, fullObjects, detail, ...formValues } =
            report.filterValue
          const filter = {
            periode: periode,
            ...formValues,
          }
          const filterValue = {
            periode,
            periodeMonth,
            dateType,
            fullObjects,
            ...formValues,
          }
          let finalFilter = {}
          Object.keys(filter).forEach((key) => {
            if (filter[key] != null) finalFilter[key] = filter[key]
          })

          if (finalFilter.vehicleId)
            finalFilter.vehicleId = Array.isArray(finalFilter.vehicleId)
              ? finalFilter.vehicleId.map((item) => parseInt(item))
              : parseInt(finalFilter.vehicleId)

          if (finalFilter.driverId)
            finalFilter.driverId = Array.isArray(finalFilter.driverId)
              ? finalFilter.driverId.map((item) => parseInt(item))
              : parseInt(finalFilter.driverId)

          if (finalFilter.geofenceId)
            finalFilter.geofenceId = Array.isArray(finalFilter.geofenceId)
              ? finalFilter.geofenceId.map((item) => parseInt(item))
              : parseInt(finalFilter.geofenceId)

          if (finalFilter.alertCode)
            finalFilter.alertCode = Array.isArray(finalFilter.alertCode)
              ? finalFilter.alertCode.map((item) => parseInt(item))
              : parseInt(finalFilter.alertCode)

          if (finalFilter.garageId)
            finalFilter.garageId = Array.isArray(finalFilter.garageId)
              ? finalFilter.garageId.map((item) => parseInt(item))
              : parseInt(finalFilter.garageId)

          if (finalFilter.startGeofenceId)
            finalFilter.startGeofenceId = Array.isArray(finalFilter.startGeofenceId)
              ? finalFilter.startGeofenceId.map((item) => parseInt(item))
              : parseInt(finalFilter.startGeofenceId)

          if (finalFilter.endGeofenceId)
            finalFilter.endGeofenceId = Array.isArray(finalFilter.endGeofenceId)
              ? finalFilter.endGeofenceId.map((item) => parseInt(item))
              : parseInt(finalFilter.endGeofenceId)

          this.saveReportFilter(filterValue, finalFilter, report.key)
          this.setReportDetail(report.key, { ...detail })

          const routeData = this.$router.resolve({ name: report.link, query: { key: report.key } })
          window.open(routeData.href, '_blank')
        } else if (!report.filter) {
          const routeData = this.$router.resolve({ name: report.link })
          window.open(routeData.href, '_blank')
        } else {
          this.openModal(report)
        }
      }
    },
    async onFavorite(key) {
      if (this.hasAccess(['favorite-reports:update'])) {
        let allReport = this.$store.state.report.reports
        let favReport = allReport.findIndex((item) => item.key == key)
        await this.$apollo
          .mutate({
            mutation: UPDATE_FAVORITE_REPORTS,
            variables: {
              input: {
                reportKey: key,
                status: !allReport[favReport].isFavorite,
                type: 'report',
              },
            },
            fetchPolicy: 'no-cache',
          })
          .then(({ res, loading }) => {
            if (!loading) {
              allReport[favReport].isFavorite = !allReport[favReport].isFavorite
              this.$store.commit('report/updateReportList', allReport)
            }
          })
      }
    },
  },
}
</script>
<style scoped lang="scss">
.icon-fill_star::before {
  color: #ff8a00 !important;
}
.icon-fill_bookmark::before {
  color: #ff8a00 !important;
}
</style>
